import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.filter.js";
// Independent functions

export var toCamel = function toCamel(s) {
  return s.replace(/([-_][a-z])/ig, function ($1) {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};
export var isArray = function isArray(a) {
  return Array.isArray(a);
};
export var isObject = function isObject(o) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function';
};
export var keysToCamel = function keysToCamel(o) {
  if (isObject(o)) {
    var n = {};
    Object.keys(o).forEach(function (k) {
      n[toCamel(k)] = keysToCamel(o[k]);
    });
    return n;
  } else if (isArray(o)) {
    return o.map(function (i) {
      return keysToCamel(i);
    });
  }
  return o;
};
export var sortByKey = function sortByKey(array, key) {
  return array.sort(function (a, b) {
    var x = a[key];
    var y = b[key];
    return x < y ? -1 : x > y ? 1 : 0;
  });
};

/**
 * It will generate a unique id.
 *
 * Math.random should be unique because of its seeding algorithm.
 * Convert it to base 36 (numbers + letters), and grab the first 9 characters
 * after the decimal.
 *
 * @returns {string}
 */
export var uniqueId = function uniqueId() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
};

/**
 * It will either add an value to the array or
 * remove it if its already exists.
 *
 * @param array
 * @param value
 * @returns {any[]|*}
 */
export var arrayToggle = function arrayToggle(array, value) {
  if (array.includes(value)) {
    var foundIndex = array.findIndex(function (item) {
      return item === value;
    });
    return array.splice(foundIndex, 1);
  }
  return array.push(value);
};

/**
 * Put this into the sort() method of an Object
 * to sort by object's property.
 *
 * Add minus (-) before property name to set descending order.
 *
 * It works with strings and numbers.
 *
 * @param property
 * @param descending
 * @returns {function(*, *): number}
 */
export var dynamicSort = function dynamicSort(property) {
  var descending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sortOrder = descending ? -1 : 1;
  return function (a, b) {
    /* next line ,
     * and you may want to customize it to your needs
     */
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};
/**
 *
 * @param targetName
 * @param startingNode
 * @returns {*}
 */
export var findComponentByName = function findComponentByName(targetName, startingNode) {
  var target;
  var findRecursively = function findRecursively(children) {
    var found = children.find(function (component) {
      return component.$options.name === targetName;
    });
    if (found) {
      target = found;
    }
    children.forEach(function (child) {
      !target && child.$children && findRecursively(child.$children);
    });
  };
  findRecursively(startingNode.$children);
  return target;
};

/**
 * Will make groups of array of objects by a given key.
 * @param list
 * @param key
 * @returns {*}
 */
export var groupArrayOfObjects = function groupArrayOfObjects(list, key) {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

/**
 * Will remove characters |# and <mark></mark> tags.
 * @param text
 * @returns {*}
 */
export var removeRedundantCharacters = function removeRedundantCharacters(text) {
  return text.replace(/\|#/g, '').replace(/<mark>|<\/mark>|#\/mark>/g, '');
};

/**
 * Will remove redundant characters and html tags.
 * @param text
 * @returns {*}
 */
export var removeHtmlTags = function removeHtmlTags(text) {
  return removeRedundantCharacters(text).replace(/(<([^>]+)>)/ig, '');
};
export var hasPermission = function hasPermission(user) {
  var _user$permissions;
  for (var _len = arguments.length, permissions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    permissions[_key - 1] = arguments[_key];
  }
  permissions = typeof permissions[0] !== 'string' ? permissions[0] : permissions;
  permissions = permissions.filter(function (r) {
    return r.length;
  });
  return !permissions.length || !!((_user$permissions = user.permissions) !== null && _user$permissions !== void 0 && _user$permissions.some(function (permission) {
    return permissions.includes(permission);
  }));
};